import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateDTPM } from '../../../store/actions/frontApp.Action';
import { FrontAppList, RootState } from '../../../../@types';
import toast from 'react-hot-toast';

interface CheckboxProps {
    originalRow: FrontAppList;
    checkboxType: 'DT' | 'PM';
}

interface UpdateStatusPayload {
    DT?: string;
    PM?: string;
}
const CheckboxInput: React.FC<CheckboxProps> = ({ originalRow, checkboxType }) => {
    const dispatch = useDispatch();
    const { loader } = useSelector((state: RootState) => state?.frontApp);
    const [statusChecked, setStatusChecked] = useState(false);
    useEffect(() => {
        if (originalRow) {
            setStatusChecked(originalRow[checkboxType] === 'Completed');
        }
    }, [originalRow?.[checkboxType], originalRow?.comment_id]);

    const handleCheckboxChange = () => {
        if (loader) return;
        if (originalRow?.timer?.isRunning) {
            toast.error("Please pause the timer");
            return;
        }
        const newValue = !statusChecked ? 'Completed' : 'NotCompleted';
        updateStatus(newValue);
    };

    const updateStatus = (value: string) => {
        const updateStatusPayload: UpdateStatusPayload = {
            DT: checkboxType === 'DT' ? value : undefined,
            PM: checkboxType === 'PM' ? value : undefined
        };

        if (checkboxType === 'DT') {
            delete updateStatusPayload.PM;
        } else if (checkboxType === 'PM') {
            delete updateStatusPayload.DT;
        }
        const comment_id = originalRow?.comment_id;
        dispatch(updateDTPM(updateStatusPayload, comment_id));
    };
    return (
        <input
            className="form-check-input"
            type="checkbox"
            style={{
                color: '#216ba5',
                cursor: loader ? 'not-allowed' : 'pointer',
                opacity: loader ? 0.6 : 1
            }}
            checked={statusChecked}
            onChange={handleCheckboxChange}
            disabled={loader}
        />
    );
}

export default CheckboxInput;
